import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";

export default function ContactAndAbout({bgVariant = 1}) {
  let bgVariantClass = bgVariant == 1 ? 'bgImageDark' : 'bgImageLight'
  
  return (
    <Container fluid className={`aboutUsContainer px-0 ${bgVariantClass}`}>
      <Row className="py-3 py-md-5 justify-content-center aboutUsRow mx-auto">
        <Col xs={12} lg={6} className='aboutUsCol'>
            <AboutUs></AboutUs>
        </Col>
        <Col xs={12} lg={6} className='aboutUsCol'>
            <ContactUs ></ContactUs>
        </Col>
      </Row>
    </Container>
  );
}
